/** @jsx jsx */
import { Dialog } from '@datacamp/waffles/dialog';
import { Text } from '@datacamp/waffles/text';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import KeyboardShortcuts from '../KeyboardShortcuts';

const listItemStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: tokens.spacing.medium,
  gap: tokens.spacing.xlarge,
};

const CompletionPaneShortcutsModal: React.FC = () => {
  const { t } = useTranslation();
  const shortcuts = [
    {
      keys: ['Ctrl', 'Shift', 'Enter'],
      label: t('CompletionPaneShortcutsModal.submitAnswer'),
    },
    {
      keys: ['Ctrl', 'Enter'],
      label: t('CompletionPaneShortcutsModal.executeLine'),
    },
    {
      keys: ['Enter'],
      label: t('CompletionPaneShortcutsModal.submitMultipleChoice'),
    },
    {
      keys: ['Ctrl', 'H'],
      label: t('CompletionPaneShortcutsModal.getHintOrSolution'),
    },
  ];

  return (
    <>
      <Dialog.Header>{t('CompletionPaneShortcutsModal.header')}</Dialog.Header>
      <Dialog.Body>
        <ul
          css={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
          }}
        >
          {shortcuts.map((shortcut) => {
            const { keys, label } = shortcut;

            return (
              <li css={listItemStyle} key={label}>
                <Text>{label}</Text>
                <KeyboardShortcuts keys={keys} />
              </li>
            );
          })}
        </ul>
      </Dialog.Body>
    </>
  );
};

export default CompletionPaneShortcutsModal;
